module.exports = __webpack_public_path__ + "img/MicroSD-and-adaptor.00ebdbc2.jpg";